import { UPDATE_WATCH_LIST_ENTRY_EU_TERRORISTS } from '../types';
import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  updateWatchListEntry,
  updateWatchListEntryPending,
  updateWatchListEntryFulfilled,
  updateWatchListEntryRejected,
} = createAsyncActions(UPDATE_WATCH_LIST_ENTRY_EU_TERRORISTS, 'updateWatchListEntry');


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/actions/updateWatchListEntryActions.js